import { type ComponentProps, type ReactNode, useId } from 'react';

import { cx } from '@/lib/cx';

import { estiloCampo } from './estilos';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input className={cx(estiloCampo, 'h-controle', className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return <textarea className={cx(estiloCampo, 'min-h-20 py-2', className)} {...props} />;
}

interface CampoProps {
  rotulo: string;
  /** Mensagem de erro do campo — liga `aria-invalid` e `aria-describedby`. */
  erro?: string | undefined;
  ajuda?: string | undefined;
  /** Informação curta ao lado do rótulo (ex.: badge "IBGE 2919207") — não ocupa linha abaixo do controle. */
  complemento?: ReactNode;
  className?: string | undefined;
  children: (atributos: {
    id: string;
    'aria-invalid'?: true;
    'aria-describedby'?: string;
  }) => ReactNode;
}

/** Rótulo + controle + ajuda/erro, com a ligação acessível feita uma vez só. */
export function Campo({ rotulo, erro, ajuda, complemento, className, children }: CampoProps) {
  const id = useId();
  const idDescricao = `${id}-descricao`;
  const descricao = erro ?? ajuda;
  return (
    <div className={cx('grid content-start gap-1.5', className)}>
      <div className="flex h-5 items-center justify-between gap-2">
        <label htmlFor={id} className="text-sm font-medium text-texto">
          {rotulo}
        </label>
        {complemento}
      </div>
      {children({
        id,
        ...(erro ? { 'aria-invalid': true as const } : {}),
        ...(descricao ? { 'aria-describedby': idDescricao } : {}),
      })}
      {descricao && (
        <p id={idDescricao} className={cx('text-xs', erro ? 'text-perigo' : 'text-texto-fraco')}>
          {descricao}
        </p>
      )}
    </div>
  );
}
